<div *ngIf="incompatible" class="custom-widget-incompatible" role="status" [style.minHeight.px]="heightPx">
  <span class="custom-widget-incompatible__name">{{ instance?.widgetId || 'Custom widget' }}</span>
  <span class="custom-widget-incompatible__message">{{ incompatibleMessage }}</span>
</div>
<div class="custom-widget-placeholder" *ngIf="!frameUrl && !incompatible" [style.height.px]="heightPx">
  <span>{{ instance?.widgetId || 'Custom widget' }}</span>
  <span *ngIf="instance?.version">v{{ instance?.version }}</span>
</div>
<ng-container *ngIf="frameUrl">
  <iframe
    #frame
    *ngIf="frameUsesBrowserOrigin; else opaqueFrame"
    class="custom-widget-frame"
    [src]="frameUrl"
    sandbox="allow-scripts allow-same-origin"
    [attr.allow]="frameAllow"
    referrerpolicy="no-referrer"
    scrolling="no"
    [style.height.px]="heightPx"
    (load)="onFrameLoad()"
    [title]="instance?.widgetId || 'Custom widget'"
  ></iframe>
  <ng-template #opaqueFrame>
    <iframe
      #frame
      class="custom-widget-frame"
      [src]="frameUrl"
      sandbox="allow-scripts"
      referrerpolicy="no-referrer"
      scrolling="no"
      [style.height.px]="heightPx"
      (load)="onFrameLoad()"
      [title]="instance?.widgetId || 'Custom widget'"
    ></iframe>
  </ng-template>
</ng-container>
